<template>
  <div>
    <b-button v-b-modal="modalKey" variant="yellow">
      {{ buttonText }}
    </b-button>
    <b-modal title="Order items" :id="modalKey">
      <p>1 = highest placement in listing</p>
      <hr />
      <b-row
        v-for="(item, itemIndex) in reordered"
        :key="itemIndex"
        class="d-flex"
      >
        <b-col>
          {{ item[optionLabel] }}
        </b-col>
        <b-col cols="3">
          <b-form-select v-model="item.order" :options="options" />
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button block variant="yellow" @click="setOrdering">
          Set ordering
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Set order for items'
    },
    optionLabel: {
      type: String,
      required: true
    },
    refreshAction: {
      type: Function,
      required: true
    },
    updateAction: {
      type: Function,
      required: true
    },
    model: {
      type: String,
      required: true
    }
  },
  data: () => ({
    reordered: []
  }),
  computed: {
    modalKey() {
      return this.model + '-ordering'
    },
    options() {
      const maxValue = this.reordered.length + 1
      const indexRange = [...Array(maxValue).keys()]
      delete indexRange[0]
      const options = indexRange.map((index) => {
        return { text: index, value: index }
      })
      return options
    },
    usedIndexes() {
      const usedIndexes = []
      this.reordered.forEach((item) => {
        if (Number.isInteger(item.order)) {
          usedIndexes.push(item.order)
        }
      })
      return usedIndexes
    }
  },
  methods: {
    async setOrdering() {
      const reorderedDataItems = this.reordered.filter((item) => {
        const originalItem = this.data.find((o) => o.id === item.id)
        const valueChanged = originalItem.order !== item.order
        return Number.isInteger(item.order) && valueChanged
      })
      await Promise.all(
        reorderedDataItems.map((item) => {
          const actionPayload = {}
          actionPayload[this.model + 'Id'] = item.id
          actionPayload[this.model + 'Data'] = JSON.stringify(item)
          this.updateAction(actionPayload)
          return item
        })
      ).then(() => {
        this.refreshAction(this.$store.state.event.activeEvent.id)
      })
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        this.reordered = JSON.parse(JSON.stringify(val))
      }
    }
  }
}
</script>
